module.exports = __webpack_public_path__ + "static/media/Step2_PainelGerencial.17a9a995.png";